export enum CustomSelectionType {
  DAILY,
  WEEKLY,
  MONTHLY,
  YEARLY,
}
